"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _ms = _interopRequireDefault(require("ms"));
var _occasion = _interopRequireDefault(require("occasion"));
var _table = _interopRequireDefault(require("../../../core/table"));
var _gbp = _interopRequireDefault(require("gbp"));
var _button = _interopRequireDefault(require("../../../core/button"));
var _detailButton = _interopRequireDefault(require("./detail-button"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
var _ref = /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", {
  className: "hidden-print"
}), /*#__PURE__*/_react.default.createElement("th", null, "Competition"), /*#__PURE__*/_react.default.createElement("th", null, "Due Date"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Amount"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-center"
}, "Status")));
class UserPayments extends _react.Component {
  _getStatusClass(paymentStatusRef) {
    if (paymentStatusRef === 'PAID') return 'text-xs-center text-success';
    if (paymentStatusRef === 'ERR' || paymentStatusRef === 'ERR1') return 'text-xs-center text-danger';
    if (paymentStatusRef === 'ACPT') return 'text-xs-center text-warning';
    return 'text-xs-center';
  }
  _getPaymentAmount(payment) {
    if (payment.paymentStatusRef === 'CANC') return '';
    return (0, _gbp.default)(payment.expectedAmount - payment.refundedByClubPreCharge);
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_table.default, null, _ref, /*#__PURE__*/_react.default.createElement("tbody", null, this.props.userPaymentsByYear.map(payment => /*#__PURE__*/_react.default.createElement("tr", {
      key: payment.id + '_paymentRow'
    }, /*#__PURE__*/_react.default.createElement("td", {
      className: "hidden-print"
    }, /*#__PURE__*/_react.default.createElement(_detailButton.default, {
      paymentID: payment.id
    })), /*#__PURE__*/_react.default.createElement("td", null, payment.competition.competitionName), /*#__PURE__*/_react.default.createElement("td", null, (0, _occasion.default)(payment.competition.paymentsChargeDate > payment.createdDate ? payment.competition.paymentsChargeDate : payment.createdDate.split('T')[0], 'D MMMM')), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, this._getPaymentAmount(payment)), /*#__PURE__*/_react.default.createElement("td", {
      className: this._getStatusClass(payment.paymentStatusRef)
    }, payment.paymentStatusDescription)))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref2 = {
  id: true,
  expectedAmount: true,
  refundedByClubPreCharge: true,
  paymentStatusRef: true,
  paymentStatusDescription: true,
  createdDate: true,
  competition: {
    competitionName: true,
    paymentsChargeDate: true
  }
};
var _default = exports.default = (0, _reactBicycle.connect)(UserPayments, props => ({
  ["userPaymentsByYear(yearID:" + JSON.stringify(+props.yearID) + ")"]: _ref2
}));